module.exports = __webpack_public_path__ + "static/media/RnR-setup-complete-slack.15b8993a.svg";